<template>
  <billing-portal-redirect />
</template>

<script>
import BillingPortalRedirect from '../../components/payment/BillingPortalRedirect';

export default {
  name: 'billing-portal',
  components: {
    BillingPortalRedirect,
  },
};
</script>

<style>
</style>
